(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const animBusy = U.animBusy;
  const dispatch = U.dispatch;
  const live = U.live;

  function isCandidate(iid) {
    if (animBusy()) return false;
    const pd = APP.state.pending;
    if (!pd || pd.kind !== "choose" || !pd.cands || pd.locChoices) return false;
    if (!U.localDecision(APP.state)) return false;
    if (pd.cands.indexOf(iid) < 0) return false;
    return cohereAllows(iid);
  }

  function cohereAllows(iid) {
    const pd = APP.state.pending;
    if (!pd || pd.cohere !== "loc") return true;
    if (APP.picked.indexOf(iid) >= 0) return true;
    if (!APP.picked.length) return true;
    const anchor = APP.state.objs[APP.picked[0]];
    const o = APP.state.objs[iid];
    return !!(anchor && o && Core.sameLoc(anchor.loc, o.loc));
  }

  function locIsCandidate(loc) {
    const pd = APP.state.pending;
    if (!pd || pd.kind !== "choose" || !pd.locChoices) return false;
    if (!U.localDecision(APP.state)) return false;
    return pd.cands.some(function (c) { return JSON.stringify(c) === JSON.stringify(loc); });
  }

  function groupable(state, p, iid) {
    const o = state.objs[iid];
    return !!o && o.zone === "board" && o.controller === p && o.ready && !o.attachedTo &&
      Core.isType(state, iid, "unit");
  }

  function groupActor(state) {
    if (!live()) return null;
    const pd = state && state.pending;
    if (!pd || pd.kind !== "act" || !U.localDecision(state)) return null;
    return pd.player;
  }

  const NO_GROUP = [];

  function moveGroup(state) {
    if (!APP.moveSel) return NO_GROUP;
    const p = groupActor(state);
    if (p === null) {
      APP.moveSel = null;
      return NO_GROUP;
    }
    const keep = APP.moveSel.filter(function (iid) { return groupable(state, p, iid); });
    if (keep.length !== APP.moveSel.length) APP.moveSel = keep;
    return APP.moveSel;
  }

  function groupOpen(state) {
    moveGroup(state);
    return APP.moveSel !== null;
  }

  function enterGroup(iid) {
    const state = APP.state;
    const p = animBusy() ? null : groupActor(state);
    if (p === null || !groupable(state, p, iid)) return false;
    APP.moveSel = [iid];
    APP.selection = null;
    APP.menu = null;
    U.render();
    return true;
  }

  function toggleGroup(iid) {
    const state = APP.state;
    const p = animBusy() ? null : groupActor(state);
    if (p === null || !groupOpen(state) || !groupable(state, p, iid)) return false;
    const g = moveGroup(state);
    const i = g.indexOf(iid);
    if (i >= 0) g.splice(i, 1);
    else g.push(iid);
    APP.selection = null;
    APP.menu = null;
    U.render();
    return true;
  }

  function clearGroup() {
    if (APP.moveSel === null) return false;
    APP.moveSel = null;
    U.render();
    return true;
  }

  function groupStrands(state, p, iid) {
    const g = moveGroup(state);
    if (!g.length || g.indexOf(iid) >= 0) return false;
    return !groupMoveDests(state, p, g.concat([iid])).length;
  }

  function groupPickable(state, iid) {
    const p = groupActor(state);
    return p !== null && groupOpen(state) && groupable(state, p, iid);
  }

  function groupCulprits(state, p, iids) {
    if (iids.length < 2 || groupMoveDests(state, p, iids).length) return [];
    return iids.filter(function (iid) {
      const rest = iids.filter(function (o) { return o !== iid; });
      return groupMoveDests(state, p, rest).length > 0;
    });
  }

  function payPd(state) {
    const pd = state.pending;
    if (!pd || pd.kind !== "pay" || !APP.manualPay) return null;
    if (!U.localDecision(state)) return null;
    return pd;
  }

  function payModes(state, pd, iid) {
    const out = [];
    for (const mode of ["exhaustRune", "recycleRune", "legend"]) {
      const act = { iid: iid, mode: mode };
      if (!RB.Play.payActLegal(state, pd.player, act, [])) continue;
      if (!RB.Play.payActGain(state, pd.player, act, pd.payCtx || {})) continue;
      out.push(mode);
    }
    return out;
  }

  function payStaged(acts, iid, mode) {
    return acts.some(function (a) { return a.iid === iid && a.mode === mode; });
  }

  function togglePayAct(iid, mode) {
    const state = APP.state;
    const pd = payPd(state);
    if (!pd) return;
    const acts = U.payActs().slice();
    const at = acts.findIndex(function (a) { return a.iid === iid && a.mode === mode; });
    if (at >= 0) acts.splice(at, 1);
    else if (RB.Play.payActLegal(state, pd.player, { iid: iid, mode: mode }, acts)) acts.push({ iid: iid, mode: mode });
    else return;
    U.setPayActs(RB.Play.orderPayActs(acts));
  }

  function payCycle(state, pd, iid) {
    const modes = payModes(state, pd, iid);
    if (!modes.length) return false;
    const acts = U.payActs();
    const on = modes.filter(function (m) { return payStaged(acts, iid, m); });
    const rest = acts.filter(function (a) { return a.iid !== iid; });
    const combos = [[]];
    for (const m of modes) combos.push([m]);
    if (modes.length > 1) combos.push(modes.slice());
    const key = function (list) { return list.slice().sort().join("+"); };
    let at = combos.findIndex(function (c) { return key(c) === key(on); });
    if (at < 0) at = 0;
    const next = combos[(at + 1) % combos.length];
    U.setPayActs(RB.Play.orderPayActs(rest.concat(next.map(function (m) {
      return { iid: iid, mode: m };
    }))));
    return true;
  }

  function payClickable(state, iid) {
    const pd = payPd(state);
    return !!pd && payModes(state, pd, iid).length > 0;
  }

  function payMarks(state, iid) {
    const pd = payPd(state);
    if (!pd) return null;
    const acts = U.payActs();
    const on = acts.filter(function (a) { return a.iid === iid; }).map(function (a) { return a.mode; });
    if (!on.length) return payModes(state, pd, iid).length ? { modes: [] } : null;
    return { modes: on };
  }

  function clickCard(iid, ev) {
    ev.stopPropagation();
    if (ZONES.squelch) return;
    const state = APP.state;
    const pd = state.pending;
    if (pd && pd.kind === "choose" && isCandidate(iid)) {
      togglePick(iid);
      return;
    }
    if (pd && pd.kind === "mulligan" && U.localDecision(state)) {
      const o = state.objs[iid];
      if (o && o.zone === "hand" && o.owner === pd.player) {
        togglePick(iid);
        return;
      }
    }
    if (groupPickable(state, iid) && !animBusy()) {
      toggleGroup(iid);
      return;
    }
    const paying = payPd(state);
    if (paying && payCycle(state, paying, iid)) return;
    if (APP.selection === iid && APP.menu) {
      closeInspector();
      return;
    }
    APP.selection = iid;
    APP.menu = { iid: iid };
    U.render();
  }

  function closeInspector() {
    if (APP.selection === null && !APP.menu && !APP.peek) return false;
    APP.selection = null;
    APP.menu = null;
    APP.peek = null;
    U.render();
    return true;
  }

  function peekCard(card) {
    if (!card) return;
    APP.selection = null;
    APP.menu = null;
    APP.peek = card;
    U.render();
  }

  function cardActions(state, iid) {
    const out = [];
    const pd = U.localDecision(state);
    if (!pd) return out;
    const actor = pd.player;
    const o = state.objs[iid];
    const c = Core.card(state, iid);
    if (!o || !c) return out;
    const window_ = ["act", "focus", "respond"].indexOf(pd.kind) >= 0;

    if (window_ && (o.zone === "hand" || o.zone === "champion") && o.owner === actor) {
      const legal = !U.LEGAL || U.LEGAL.play[iid];
      out.push({
        label: Core.isType(state, iid, "spell") ? "Cast " + c.name : "Play " + c.name,
        primary: true, disabled: !legal,
        why: legal ? null : whyUnplayable(state, actor, iid),
        fn: function () { dispatch({ type: "PLAY_CARD", player: actor, iid: iid }); },
      });
      if (pd.kind === "act" && Core.hasKw(state, iid, "hidden")) {
        const hideCosts = RB.Play.hideCosts(state, actor);
        const costLabel = function (cost) {
          if (!cost.energy && !cost.anyPower) return "free";
          if (cost.energy) return cost.energy + " energy";
          return cost.anyPower + " power";
        };
        for (const bfIid of state.battlefields) {
          const bf = state.objs[bfIid];
          if (bf.controller !== actor || !RB.Flow.hideSlotFree(state, bfIid)) continue;
          for (let ci = 0; ci < hideCosts.length; ci++) {
            (function (bfIid, ci) {
              const cost = hideCosts[ci];
              const why = RB.Play.hideBlocked(state, actor, iid, bfIid, ci);
              const suffix = hideCosts.length > 1 ? " for " + costLabel(cost) : "";
              out.push({
                label: "Hide at " + Core.name(state, bfIid) + suffix,
                disabled: !!why,
                why: why ? why.charAt(0).toUpperCase() + why.slice(1) + "." : null,
                fn: function () { dispatch({ type: "HIDE", player: actor, iid: iid, bf: bfIid, costIdx: ci }); },
              });
            })(bfIid, ci);
          }
        }
      }
    }

    if (window_ && o.zone === "trash" && o.owner === actor) {
      const fsc = RB.Scripts.forCard(state, iid);
      const flow = Core.isType(state, iid, "spell") && ((fsc && fsc.flowCost) || RB.Play.flowGrant(state, iid));
      const trashLegal = U.LEGAL ? !!U.LEGAL.play[iid] : !whyUnplayable(state, actor, iid);
      if (flow || trashLegal) {
        out.push({
          label: "Play from trash" + (flow ? " (Flow)" : ""), primary: true, disabled: !trashLegal,
          why: trashLegal ? null : whyUnplayable(state, actor, iid),
          fn: function () { dispatch({ type: "PLAY_CARD", player: actor, iid: iid }); },
        });
      }
    }

    if (window_ && o.zone === "facedown" && o.owner === actor) {
      const fdLegal = !U.LEGAL || !!U.LEGAL.play[iid];
      out.push({
        label: "Reveal and play", primary: true, disabled: !fdLegal,
        why: fdLegal ? null : whyUnplayable(state, actor, iid),
        fn: function () { dispatch({ type: "PLAY_CARD", player: actor, iid: iid }); },
      });
    }

    if (pd.kind === "act" && o.zone === "board" && o.controller === actor &&
      Core.isType(state, iid, "unit") && !o.attachedTo) {
      if (!o.ready) {
        out.push({ label: "Move", disabled: true, why: c.name + " is exhausted." });
      } else {
        for (const dest of dragMoveDests(state, actor, iid)) {
          (function (dest) {
            out.push({
              label: dest.t === "base" ? "Return to base" : "Move to " + Core.name(state, dest.iid),
              fn: function () {
                dispatch({ type: "STANDARD_MOVE", player: actor, units: [iid], dest: dest });
              },
            });
          })(dest);
        }
        const open = groupOpen(state);
        const inGroup = moveGroup(state).indexOf(iid) >= 0;
        const strands = groupStrands(state, actor, iid);
        out.push({
          label: !open ? "Move as a group…" : inGroup ? "Remove from the group" : "Add to the group",
          disabled: strands,
          why: strands ? "Shares no destination with the group." : null,
          fn: function () { if (open) toggleGroup(iid); else enterGroup(iid); },
        });
      }
    }

    if (["act", "focus", "respond", "pay"].indexOf(pd.kind) >= 0) {
      const paying = payPd(state);
      const stageLabel = { exhaustRune: "Exhaust for 1 energy", recycleRune: "Recycle for 1 power", legend: "Add resources" };
      if (paying) {
        const acts = U.payActs();
        for (const mode of payModes(state, paying, iid)) {
          (function (mode) {
            const on = payStaged(acts, iid, mode);
            out.push({
              label: (on ? "Unstage: " : "") + stageLabel[mode],
              fn: function () { togglePayAct(iid, mode); },
            });
          })(mode);
        }
      } else {
        if (Core.isType(state, iid, "rune") && o.zone === "board" && o.controller === actor) {
          if (o.ready) {
            out.push({
              label: stageLabel.exhaustRune,
              fn: function () { dispatch({ type: "ACTIVATE", player: actor, iid: iid, mode: "exhaustRune" }); },
            });
          }
          out.push({
            label: stageLabel.recycleRune,
            fn: function () { dispatch({ type: "ACTIVATE", player: actor, iid: iid, mode: "recycleRune" }); },
          });
        }
        if (iid === state.players[actor].legendIid && RB.Scripts.legendAdd(state, iid)) {
          out.push({
            label: stageLabel.legend, disabled: !o.ready,
            why: o.ready ? null : "Your legend is exhausted.",
            fn: function () { dispatch({ type: "ACTIVATE", player: actor, iid: iid, mode: "legend" }); },
          });
        }
      }
      const abList = (o.zone === "board" || o.zone === "legendZone") && o.controller === actor
        ? RB.Scripts.abilitiesOf(state, iid) : [];
      for (let i = 0; i < abList.length; i++) {
        (function (i) {
          const ab = abList[i];
          const legal = !U.LEGAL || U.LEGAL.abil[iid + ":" + i];
          const from = ab.inheritedFrom && state.objs[ab.inheritedFrom]
            ? " (from " + Core.name(state, ab.inheritedFrom) + ")" : "";
          const price = U.abilityCostLabel(ab);
          out.push({
            label: (ab.label || "Ability " + (i + 1)) + (price ? " — " + price : "") + from, disabled: !legal,
            why: legal ? null : "Not available right now.",
            fn: function () { dispatch({ type: "ACTIVATE", player: actor, iid: iid, ability: i }); },
          });
        })(i);
      }
    }
    return out;
  }

  function whyUnplayable(state, p, iid) {
    const why = RB.Play.playBlocked(state, p, iid, state.pending.kind);
    if (!why) return null;
    return why.charAt(0).toUpperCase() + why.slice(1) + ".";
  }

  function togglePick(iid) {
    const pd = APP.state.pending;
    const i = APP.picked.indexOf(iid);
    if (i >= 0) APP.picked.splice(i, 1);
    else {
      APP.picked.push(iid);
      if (pd.kind === "choose" && APP.picked.length > (pd.max || 1)) APP.picked.shift();
      if (pd.kind === "mulligan" && APP.picked.length > 2) APP.picked.shift();
    }
    if (pd.kind === "choose" && i < 0 && String(iid).indexOf("chain:") !== 0) {
      const c = Core.card(APP.state, iid);
      if (c) { APP.peek = c; APP.selection = null; APP.menu = null; }
    }
    U.render();
  }

  function clickLoc(loc, ev) {
    ev.stopPropagation();
    if (ZONES.squelch) return;
    const state = APP.state;
    const pd = state.pending;
    if (pd && pd.kind === "choose" && pd.locChoices && locIsCandidate(loc)) {
      dispatch({ type: "CHOOSE", player: pd.player, picks: [loc] });
      return;
    }
    const p = groupActor(state);
    const g = moveGroup(state);
    if (p !== null && g.length && !animBusy()) {
      const legal = groupMoveDests(state, p, g)
        .some(function (d) { return locKey(d) === locKey(loc); });
      if (legal) {
        dispatch({ type: "STANDARD_MOVE", player: p, units: g.slice(), dest: loc });
        return;
      }
    }
    closeInspector();
  }

  function clickTable() {
    if (ZONES.squelch) return;
    if (window.UIDOM.textSelected()) return;
    if (clearGroup()) return;
    closeInspector();
  }

  const ZONES = { list: [], ghost: null, hover: null, squelch: false };

  function groupMoveDests(state, p, iids) {
    if (!iids.length) return [];
    let common = null;
    for (const iid of iids) {
      const keys = {};
      for (const d of dragMoveDests(state, p, iid)) keys[locKey(d)] = d;
      if (common === null) {
        common = keys;
      } else {
        for (const k in common) if (!keys[k]) delete common[k];
      }
    }
    const out = [];
    for (const k in common) out.push(common[k]);
    return out;
  }

  function dragUnits(state, c) {
    const g = moveGroup(state);
    return g.length > 1 && g.indexOf(c.iid) >= 0 ? g.slice() : [c.iid];
  }

  function dragMoveDests(state, p, iid) {
    return RB.Play.moveDests(state, p, [iid]);
  }

  function dragPlayDests(state, p, iid) {
    if (Core.isType(state, iid, "unit")) {
      return RB.Play.playLocations(state, { controller: p, iid: iid });
    }
    return null;
  }

  function beginDrag(iid, kind, ev) {
    if (!live() || !ev || ev.clientX === undefined || ev.button === 2) return;
    const state = APP.state;
    const pd = U.localDecision(state);
    if (!pd) return;
    if (kind === "hand") {
      if (["act", "focus", "respond"].indexOf(pd.kind) < 0) return;
      const o = state.objs[iid];
      if (!o || (o.zone !== "hand" && o.zone !== "champion") || o.owner !== pd.player) return;
      if (U.LEGAL && !U.LEGAL.play[iid]) return;
    } else {
      if (pd.kind !== "act") return;
      const o = state.objs[iid];
      if (!o || o.zone !== "board" || o.controller !== pd.player || !o.ready || o.attachedTo) return;
      if (!Core.isType(state, iid, "unit")) return;
      if (!dragMoveDests(state, pd.player, iid).length) return;
    }
    DRAG.arm({ iid: iid, kind: kind, player: pd.player }, ev);
  }

  function locKey(loc) {
    if (!loc) return "table";
    return loc.t === "base" ? "base-" + loc.p : "bf-" + loc.iid;
  }

  function activateDrag(c) {
    const state = APP.state;
    ZONES.list = [];
    let dests;
    let g0count = 0;
    if (c.kind === "hand") {
      dests = dragPlayDests(state, c.player, c.iid);
      if (dests === null) {
        ZONES.list.push({ key: "table", loc: null });
        dests = [];
      }
    } else {
      const units = dragUnits(state, c);
      dests = units.length > 1
        ? groupMoveDests(state, c.player, units)
        : dragMoveDests(state, c.player, c.iid);
      if (units.length > 1) g0count = units.length;
    }
    for (const loc of dests) ZONES.list.push({ key: locKey(loc), loc: loc });
    for (const z of ZONES.list) {
      const e = document.querySelector("[data-anchor='" + z.key + "']");
      if (e) e.classList.add("dropok");
    }
    const g = document.createElement("div");
    g.className = "dragghost";
    const card = Core.card(state, c.iid);
    if (RB.hasArt(card)) {
      g.style.backgroundImage = RB.artCssAt(card, 100);
      if (c.kind === "hand" && !Core.isType(state, c.iid, "unit")) {
        g.style.backgroundSize = "cover";
        g.style.backgroundPosition = "center";
        g.style.height = "96px";
      } else {
        g.style.backgroundSize = "auto 290%";
        g.style.backgroundPosition = "50% 24%";
      }
    }
    if (g0count > 1) g.appendChild(U.el("div", "ghostcount", String(g0count)));
    document.body.appendChild(g);
    ZONES.ghost = g;
    document.body.classList.add("dragging");
  }

  function dragHoverZone(x, y) {
    if (!document.elementFromPoint) return null;
    if (ZONES.ghost) ZONES.ghost.style.display = "none";
    let e = document.elementFromPoint(x, y);
    if (ZONES.ghost) ZONES.ghost.style.display = "";
    while (e && e.getAttribute) {
      const a = e.getAttribute("data-anchor");
      if (a && a.indexOf("hand-") === 0) return null;
      if (a) {
        const z = ZONES.list.find(function (z2) { return z2.key === a; });
        if (z) return z;
        if (a === "table") {
          const z2 = ZONES.list.find(function (z3) { return z3.key === "table"; });
          if (z2) return z2;
        }
      }
      e = e.parentElement;
    }
    return ZONES.list.find(function (z) { return z.key === "table"; }) || null;
  }

  function endDrag(c, ev, wasActive) {
    let zone = null;
    if (wasActive && ev) zone = dragHoverZone(ev.clientX, ev.clientY);
    for (const z of ZONES.list) {
      const e = document.querySelector("[data-anchor='" + z.key + "']");
      if (e) { e.classList.remove("dropok"); e.classList.remove("drophover"); }
    }
    if (ZONES.ghost) { ZONES.ghost.remove(); ZONES.ghost = null; }
    if (document.body && document.body.classList) document.body.classList.remove("dragging");
    ZONES.list = [];
    ZONES.hover = null;
    if (!wasActive) return;
    ZONES.squelch = true;
    setTimeout(function () { ZONES.squelch = false; }, 250);
    if (!zone) return;
    if (c.kind === "hand") {
      dispatch({ type: "PLAY_CARD", player: c.player, iid: c.iid });
      const pd = APP.state.pending;
      if (zone.loc && pd && pd.kind === "choose" && pd.tag === "location" && pd.locChoices &&
        pd.cands.some(function (l) { return JSON.stringify(l) === JSON.stringify(zone.loc); })) {
        dispatch({ type: "CHOOSE", player: pd.player, picks: [zone.loc] });
      }
    } else {
      dispatch({ type: "STANDARD_MOVE", player: c.player, units: dragUnits(APP.state, c), dest: zone.loc });
    }
  }

  function moveDrag(c, ev) {
    if (ZONES.ghost) {
      ZONES.ghost.style.left = (ev.clientX - 34) + "px";
      ZONES.ghost.style.top = (ev.clientY - 46) + "px";
    }
    const z = dragHoverZone(ev.clientX, ev.clientY);
    if (z !== ZONES.hover) {
      if (ZONES.hover) {
        const pe = document.querySelector("[data-anchor='" + ZONES.hover.key + "']");
        if (pe) pe.classList.remove("drophover");
      }
      if (z) {
        const ne = document.querySelector("[data-anchor='" + z.key + "']");
        if (ne) ne.classList.add("drophover");
      }
      ZONES.hover = z;
    }
  }

  const DRAG = window.UIDOM.pointerDrag({ start: activateDrag, move: moveDrag, end: endDrag });

  if (typeof document !== "undefined" && document.addEventListener) {
    document.addEventListener("click", function (ev) {
      if (ZONES.squelch) return;
      if (window.UIDOM.textSelected()) return;
      if ((APP.selection === null) && !APP.menu && !APP.peek) return;
      let e = ev.target;
      while (e) {
        if (e.id === "selpanel" || e.id === "piledlg" || e.id === "cardmenu" || e.id === "choicemenu") return;
        e = e.parentElement;
      }
      if (APP.drawer) { U.setDrawer(false); return; }
      closeInspector();
    });
    const inField = function (ev) {
      const t = ev.target;
      return !!(t && (t.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].indexOf(t.tagName) >= 0));
    };
    const modalUp = function () {
      return !!(document.getElementById("choicemenu") || document.querySelector("#arena .aroverlay") || document.getElementById("modaltab"));
    };
    document.addEventListener("contextmenu", function (ev) {
      if (APP.screen !== "game" || inField(ev)) return;
      ev.preventDefault();
    });
    document.addEventListener("mousedown", function (ev) {
      if (ev.button !== 2 || APP.screen !== "game" || inField(ev)) return;
      if (modalUp()) {
        U.setModalMin(!APP.modalMin);
        return;
      }
      U.setHoldPass(true);
      if (U.passAvailable(APP.state)) dispatch({ type: "PASS", player: APP.state.pending.player });
      else U.render();
    });
    const release = function () {
      if (!APP.holdPass) return;
      U.setHoldPass(false);
      if (APP.screen === "game") U.render();
    };
    document.addEventListener("mouseup", function (ev) { if (ev.button === 2) release(); });
    window.addEventListener("blur", release);
    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape") {
        if (APP.drawer) { U.setDrawer(false); return; }
        if (clearGroup()) return;
        closeInspector();
        return;
      }
      if (ev.key !== "l" && ev.key !== "L") return;
      if (ev.ctrlKey || ev.metaKey || ev.altKey) return;
      const t = ev.target;
      if (t && (t.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].indexOf(t.tagName) >= 0)) return;
      if (APP.screen !== "game") return;
      U.setShowLog(!APP.showLog);
    });
  }

  function abilityCostLabel(ab) {
    const parts = [];
    if (ab.exhausts) parts.push("Exhaust");
    const res = ab.cost;
    if (res) {
      const cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
      if (res.energy) parts.push(res.energy + " Energy");
      if (res.pips) {
        const doms = res.domains && res.domains.length ? res.domains.map(cap).join("/") + " " : "";
        parts.push(res.pips + " " + doms + "Power");
      }
      if (res.anyPower) parts.push(res.anyPower + " Power");
    }
    return parts.join(" + ");
  }

  Object.assign(U, { abilityCostLabel: abilityCostLabel, isCandidate: isCandidate, cohereAllows: cohereAllows, locIsCandidate: locIsCandidate, groupable: groupable, clickCard: clickCard, closeInspector: closeInspector, peekCard: peekCard, cardActions: cardActions, togglePick: togglePick, clickLoc: clickLoc, clickTable: clickTable, groupMoveDests: groupMoveDests, groupActor: groupActor, moveGroup: moveGroup, groupOpen: groupOpen, groupPickable: groupPickable, enterGroup: enterGroup, toggleGroup: toggleGroup, clearGroup: clearGroup, groupStrands: groupStrands, groupCulprits: groupCulprits, beginDrag: beginDrag, locKey: locKey, payPd: payPd, payModes: payModes, payStaged: payStaged, togglePayAct: togglePayAct, payClickable: payClickable, payMarks: payMarks });
})();
